import React from 'react';
import { Typography, GRAY } from '@applyboard/ui-components';
var TestName = function TestName(_ref) {
  var children = _ref.children;
  return /*#__PURE__*/React.createElement(Typography, {
    variant: "caption",
    style: {
      color: GRAY[10]
    }
  }, children);
};
export default TestName;